import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React, {ChangeEvent, useEffect, useReducer, useRef, useState} from 'react';
import { TextField, Button, Stack, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAssetById, deleteAssetById, putAssetById, postAsset} from "../../API/assetAPI";
import  { getAll, getAllWithQuery, getCheckTicNum, getParks } from "../../API/microAPI";
import {Helmet} from "react-helmet";
import APIService from "../../../services/api.service";
import useAPI from "../../../services/hooks/useAPI";
import environment from "../../../environment/environment";
import APIOptions from "../../../models/apiOptions";
import { CacheService } from "../../../common/services/cache.service";
import { Parks } from "../../../models/ticNum";
import { useRecoilState } from "recoil";
import { parksState } from "../../../atoms/parks";
import { tokenState } from "../../../atoms/token";

const RequestTicNum = () => {
  const axios = require('axios');
  const initialForm = {
    ParkName: '',
    parkId: '',
    title: '',
    infoType: '',
    pmisNumber: '',
    comments: ''
  };
  const navigate = useNavigate();
  const [ticStatus, setTicStatus] = useState(null);
  const [ticNum, setTicNum] = useState(null);
  const [ticRequest, setRequest] = useState(null);
  const [reload, setReload] = useState(true);
  const [parks, setParks] = useRecoilState(parksState);
  const [token, setToken] = useRecoilState(tokenState);

  const [form, setForm] = useReducer(
    (form, updates) => ({...form, ...updates}),
    initialForm
  );
  
  const infoTypes= [ {
    value: 'B',
    label: 'Boundary Survey',
  }, {
    value: 'D',
    label: 'Document',
  },
  {
    value: "E-TIC Drawing",
    label: "E-TIC Drawing"
  }, {
    value: 'M',
    label: 'Map',
  }
];

  const handleGenerateTicNumClick = async () => {
    //const queryString = `?InfoTypeCode=${form?.InfoType}&parkCode=${parks.find(x => x.name ==form?.ParkName).code}&documentTitle=${form?.Title}`
    const url = `${environment.npgAPI}etic/generateticnumber?checkconflict&createrecord`;
    const apiService = new APIService<Parks>(axios, new CacheService, url, token);
    
    apiService.add(form).then((res:any) => {
      console.log('tic',res);

      setReload(false);
      if(res.status == 'Assigned') {
        setTicNum(res.assignedTicNumber.ticNumber);
        setTicStatus(res.status); 
      }
      if(res.status == 'Existing') {
        //setTicNum(res.existingTicNumber.id);
        setTicStatus(res.status);
      }
      // status requested
    });
  }

  const handleGenerateTicRequestClick = async () => {
    //const queryString = `?InfoTypeCode=${form?.InfoType}&parkCode=${parks.find(x => x.name ==form?.ParkName).code}&documentTitle=${form?.Title}`
    const url = `${environment.npgAPI}etic/generateticnumber?checkconflict&createrequest`;
    const apiService = new APIService<Parks>(axios, new CacheService, url, token);
    
    apiService.add(form).then((res:any) => {
      setRequest(res);
      setTicNum(res.existingTicNumber.id);
      setTicStatus(res.status);
      setReload(true);
      setForm(initialForm);
      console.log('tic',res);
    });
  }

  const handleSubmit = (event) => {
    event.preventDefault();
  }
  
  const handleChange = (fieldName: string, value: any) => {
    if(fieldName == 'ParkName') { 
      let parkId = parks.find(x => x.name == value).id;
      setForm({'parkId': parkId});
      setForm({'ParkName': value});

    }
    else 
      setForm({[fieldName]: value});
  }

  const viewRequestedTicNumbers = () => { 
    navigate('/ticNumbers');
  }

  const handleNewRequest = () => { 
    setTicStatus(null);
    setTicNum(null);
    setRequest(null);
    setReload(true);
    setForm(initialForm);
  }

  const renderTicConflict = () => { 
    return (
      <>
        <h2>Tic Number Already Exists For This Request</h2>
        {ticRequest ?
          <>
            <p><span className="bold">Tic Request Id:</span> {ticRequest.requestedTicNumber.id}</p> 

            <Button
              id="save"
              variant="contained"
              className=""
              disabled={!form?.parkId || !form?.infoType || !form?.title }
              startIcon={<FontAwesomeIcon icon={["fas", "floppy-disk-circle-arrow-right"]} />}
              onClick={() => { handleGenerateTicNumClick(); }}>
                Submit
            </Button>
          </>
          :
          <>
            <Stack className="center" spacing={2} direction="column" sx={{marginBottom: 2}}>
              <Button
                id="conflict"
                variant="contained"
                className=""
                disabled={!form?.parkId || !form?.infoType || !form?.title }
                startIcon={<FontAwesomeIcon icon={["fas", "floppy-disk-circle-arrow-right"]} />}
                onClick={() => { handleGenerateTicRequestClick(); }}>
                  Request new Tic Number
              </Button>

              <Button
                id="view"
                variant="contained"
                className=""
                startIcon={<FontAwesomeIcon icon={["fas", "arrow-right"]} />}
                onClick={() => { viewRequestedTicNumbers(); }}>
                  View Requested Tic Numbers
              </Button>
            </Stack>
          </>
          
        }
        
      </>
    );
  }

  const renderTicSuccess = () => { 
    let code = parks.find(x => x.id ==form?.parkId).code;
    let alpha = parks.find(x => x.id ==form?.parkId).alpha;

    return (
      <>
        <h2>Congratulations! Here is the requested TIC Number:</h2>
        <h2 className="bold">Tic Number: {code}/{ticNum}</h2> 

        <h2 className="bold">Park Alpha: {alpha}</h2> 
        <h2 className="bold">Park Code: {code}</h2> 
        
        <Stack className="center" spacing={2} direction="column" sx={{marginBottom: 2}}>

          <Button
            id="new"
            variant="contained"
            className=""
            startIcon={<FontAwesomeIcon icon={["fas", "plus"]} />}
            onClick={() => { handleNewRequest(); }}>
              Request Another Tic Number
          </Button>

          <Button
            id="view"
            variant="contained"
            className=""
            startIcon={<FontAwesomeIcon icon={["fas", "arrow-right"]} />}
            onClick={() => { viewRequestedTicNumbers(); }}>
              View Requested Tic Numbers
          </Button>
        </Stack>
      </>
    );
  }
  return (

    <div className="standard-margin">
      <Helmet>
        <meta charSet="utf-8"/>
        <title>Request Tic Number</title>
      </Helmet>

      <Card sx={{ minWidth: 275 }} >
        <CardContent className="record-form" style={{marginBottom: '50px'}}>
          <h2>Request A Tic Number</h2>
            
          <form onSubmit={handleSubmit} aria-disabled className="record-form">
            <Stack className="center" spacing={2} direction="column" sx={{marginBottom: 2}}>
              { ticStatus ?
                <>
                  {ticStatus == 'Assigned' ? renderTicSuccess() : renderTicConflict()}
                </>
                :
                <Button
                  id="save"
                  variant="contained"
                  className=""
                  disabled={!form?.parkId || !form?.infoType || !form?.title }
                  startIcon={<FontAwesomeIcon icon={["fas", "floppy-disk-circle-arrow-right"]} />}
                  onClick={() => { handleGenerateTicNumClick(); }}>
                    Submit
                </Button>
              }
            </Stack>

            <Stack className="center" spacing={2} direction="column" sx={{marginBottom: 2}}>
              <TextField
                    type="text"
                    variant='outlined'
                    color='primary'
                    label="Park Name"
                    disabled={!reload || !parks.length}
                    onChange={e => handleChange('ParkName', e.target.value)}
                    value={form?.ParkName}
                    sx={{width: 600}} 
                    size="small"
                    required
                    select>
                    {parks.map((option) => (
                      <MenuItem key={option.id} value={option.name}>
                        {option.name}
                      </MenuItem>
                    ))}
              </TextField>

              <TextField
                  type="text"
                  variant='outlined'
                  color='secondary'
                  label="Info Type"
                  disabled={!reload}
                  onChange={e => handleChange('infoType', e.target.value)}
                  value={form?.infoType}
                    InputLabelProps={{shrink: true}}
                  required
                  sx={{width: 600}} 
                  size="small"
                  select>
                    {infoTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
              </TextField>

              <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Title"
                    disabled={!reload}
                    onChange={e => handleChange('title', e.target.value)}
                    value={form?.title}
                    sx={{width: 600}} 
                    size="small"
                    required
                    InputLabelProps={{shrink: true}}
              />
        
              <TextField
                  type="text"
                  variant='outlined'
                  color='secondary'
                  label="PMIS #"
                  disabled={!reload}
                  onChange={e => handleChange('pmisNumber', e.target.value)}
                  value={form?.pmisNumber}
                  sx={{width: 600}} 
                  size="small"
              />

              <TextField
                disabled={!reload}
                type="text"
                variant='outlined'
                color='secondary'
                label="Comments"
                onChange={e => handleChange('comments', e.target.value)}
                value={form?.comments}
                fullWidth
                sx={{width: 1000}}
                size="medium"
                inputProps={{maxLength: 1000}}
              />
            </Stack>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}

export default RequestTicNum;